import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ExplorePage from './pages/Explore';
import PetPage from './pages/Pet';
import './index.css';

// Log build metadata once on app bootstrap for debugging/deployment tracking.
// eslint-disable-next-line no-console
console.log(
  '[NFC Explore] build hash:',
  __BUILD_HASH__,
  'mode:',
  __BUILD_MODE__,
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ExplorePage />} />
        <Route path="/pet/:id" element={<PetPage />} />
        <Route path="/:id" element={<ExplorePage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
